import { render, staticRenderFns } from "./IconCaretDesc.vue?vue&type=template&id=17a87927&"
import script from "./IconCaretDesc.vue?vue&type=script&lang=js&"
export * from "./IconCaretDesc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports